module.exports = __webpack_public_path__ + "img/car-inactive.5b3401a5.svg";